
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RyderUIModule } from '@ryder/ryder-ui-library';

@Component({
    selector: 'app-user-confirmation-modal',
    imports: [RyderUIModule],
    templateUrl: './user-confirmation-modal.component.html',
    styleUrls: ['./user-confirmation-modal.component.scss']
})
export class UserConfirmationModalComponent {
  @Input() title: string;
  @Input() bodyText: string;

  @Output() onConfirm = new EventEmitter();
  
  modalAction(isConfirm: boolean) {
    this.onConfirm.emit(isConfirm);
  }
}
